import classnames from 'classnames/bind';
import React from 'react';
import { FluentSvgIcon } from './FluentSvgIcon';
import { IconButtonProps } from '../schema/FluentSvgIcon.types';

const styles = require('./IconButton.scss');
const cx = classnames.bind(styles);

export const IconButton = React.forwardRef(
    (props: IconButtonProps, ref?: React.RefObject<any>): JSX.Element => {
        const {
            icon,
            iconStyles,
            iconContainerStyles,
            ariaLabel,
            disabled,
            ariaHasPopup,
            onClick,
            ariaLive,
            tabIndex,
            className,
            primary,
            ...remainingProps
        } = props;

        return (
            <button
                ref={ref}
                className={cx(
                    cx(
                        styles.button,
                        primary && styles.primaryButton,
                        disabled && styles.disabledButton
                    ),
                    className
                )}
                role={'button'}
                tabIndex={tabIndex ? tabIndex : 0}
                aria-label={ariaLabel}
                aria-live={ariaLive}
                aria-haspopup={!!ariaHasPopup}
                aria-disabled={disabled}
                onClick={onClick}
                {...remainingProps}>
                <FluentSvgIcon
                    icon={icon}
                    iconContainerStyles={iconContainerStyles}
                    iconStyles={iconStyles}
                />
            </button>
        );
    }
);
